function convertToUnderscoreFormat(input) {
    // Split the input string by '/'
    const parts = input.split('/');

    // If there are two parts separated by '/', replace '/' with '_'
    if (parts.length === 2) {
        return `${parts[0]}_${parts[1]}`;
    } else {
        // If there are not exactly two parts, return the original input
        return input;
    }
}

export default convertToUnderscoreFormat;
